import { Pipe, PipeTransform } from "@angular/core";
@Pipe({
  name: "GIS360FilterPipe",
})
export class GIS360FilterPipe implements PipeTransform {
  // Sales Order No: contains, ignores case. Customer Name: exact match, case sensitive.
  // License Key: exact match on any key of the row, ignores case [same as SCAL].
  transform(info, filterSalesOrderNo, filterCustomerName, filterLicenseKey) {
    const salesOrderNo = (filterSalesOrderNo || "").trim().toLowerCase();
    const licenseKey = (filterLicenseKey || "").trim().toLowerCase();
    if (info.length === 0 || (salesOrderNo == "" && filterCustomerName == "" && licenseKey == "")) {
      return info;
    } else {
      return info.filter((item) => {
        const salesOrderNoMatches =
          salesOrderNo == "" || (item.SalesOrderNo != null && item.SalesOrderNo.toLowerCase().indexOf(salesOrderNo) !== -1);
        const customerNameMatches = filterCustomerName == "" || item.CustomerName === filterCustomerName;
        const LicenseKeyList = (item.LicenseKey || "").split(",");
        const licenseKeyMatches =
          licenseKey == "" ||
          LicenseKeyList.some((key) => {
            return key.toLowerCase() === licenseKey;
          });
        return salesOrderNoMatches && customerNameMatches && licenseKeyMatches;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/gis360/pipes/gis360FilterPipe.ts